import {
  LuBug,
  LuClipboardList,
  LuCode,
  LuFileText,
  LuCircleHelp,
  LuMessageSquare,
  LuPalette,
  LuRocket,
  LuSearch,
  LuShield,
  LuTarget,
  LuTrendingUp,
  LuUsers,
  LuSettings,
} from "react-icons/lu";

export const chatGptAdsHeroData = {
  backgroundImage: "/images/serviceBanners/ChatGPT_Image_dark.webp",
  whiteImage: "/images/serviceBanners/ChatGPT_image_light.webp",
  subTitle: "ChatGPT Ads Services",
  title: (
    <>
      Maximize Brand Visibility with{" "}
      <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-purple-600 dark:from-cyan-400 dark:to-purple-600">
        ChatGPT Ads Services
      </span>
    </>
  ),
  description:
    "We build strategic ChatGPT Advertising Services that help businesses reach relevant audiences within ChatGPT advertising experiences, improve campaign visibility, and support qualified traffic through focused targeting, optimized ad delivery, and performance-driven campaign management.",
  primaryButton: {
    title: "Get a Free Quote",
    onClick: () => console.log("Get Started clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("View Our Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "Targeted Ad Visibility",
      desc: "Reach users through relevant conversation context and campaign signals to improve ad relevance and decision-stage reach.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "ChatGPT Campaign Optimization",
      desc: "Manage budgets, bids, campaign settings, and ongoing optimization to maximize advertising performance and ROI.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Audience Relevance",
      desc: "Identify relevant user interests, conversation themes, and commercial intent to present compelling brand offers.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Performance-Focused Growth",
      desc: "Optimize advertising around qualified traffic, high-intent lead generation, and measurable business actions.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/reactjs.svg",
      top: "8%",
      right: "16%",
      containerSize: 70,
      iconSize: 50,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/python.svg",
      top: "20%",
      right: "22%",
      containerSize: 60,
      iconSize: 40,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};

export const chatGptAdsAboutData = [
  {
    title: "Reach Users During Active Consideration",
    content: (
      <>
        ChatGPT Ads Services can support businesses that want to appear while potential customers are researching solutions, comparing options, or considering a purchase. Instead of treating every impression as equally valuable, the strategy should focus on moments where a user is actively evaluating a need. Tycho Technologies approaches ChatGPT Advertising Services with this decision-stage context in mind, helping businesses present clear offers when relevant conversations indicate genuine interest. This makes the channel particularly useful for service providers, technology companies, ecommerce businesses, and brands with clearly defined customer problems and solutions.
      </>
    ),
  },
  {
    title: "Build Stronger Offer and Message Relevance",
    content: (
      <>
        Successful advertising depends on more than visibility. Businesses need a clear value proposition that explains what they offer, who it is designed for, and why a user should consider taking the next step. A ChatGPT Advertising Agency should therefore review service positioning, offer clarity, trust information, and supporting website content before scaling activity. ChatGPT Ads Management Services can also help businesses identify which products, services, or customer problems deserve greater advertising focus. This creates more relevant communication without relying on generic promotional language or aggressive sales messaging.
      </>
    ),
  },
  {
    title: "Connect ChatGPT Advertising With Wider Paid Media",
    content: (
      <>
        ChatGPT Ads should work as part of a broader acquisition strategy rather than as an isolated advertising channel. Businesses already investing in{" "}
        <a href="https://tychotechnologies.com/ppc-paid-advertising-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          PPC Services India
        </a>{" "}
        can compare search-led demand with conversational discovery to understand where each channel contributes value. ChatGPT Ads Services in India can complement existing paid search, social advertising, and remarketing efforts by adding another route for reaching high-intent audiences. Coordinated messaging across channels also helps maintain consistency when customers interact with a brand through multiple platforms before making an enquiry or purchase decision.
      </>
    ),
  },
  {
    title: "Improve Measurement Readiness and Growth Intelligence",
    content: (
      <>
        Reliable advertising decisions depend on meaningful conversion data, clear event definitions, and responsible measurement practices. Businesses using ChatGPT Advertising Services in India should identify valuable actions such as enquiries, registrations, purchases, or other relevant outcomes before assessing campaign effectiveness. Tycho Technologies can connect advertising insights with{" "}
        <a href="https://tychotechnologies.com/growth-analytics-ai-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          Growth Analytics AI Services India
        </a>{" "}
        to help businesses examine customer acquisition patterns, conversion quality, and broader growth signals. This creates a stronger foundation for evaluating marketing efficiency, identifying useful opportunities, and making informed decisions about future advertising investment without depending only on clicks or surface-level engagement metrics.
      </>
    ),
  },
];

export const chatGptAdsDevelopSolutionsAndProcessData = {
  buildSubtitle: "STRATEGIC SOLUTIONS",
  buildTitle: "Strategic ChatGPT Ads Solutions for Stronger Campaign Visibility",
  buildCards: [
    {
      title: "ChatGPT Ads Campaign Setup",
      desc: "Create structured campaigns aligned with business goals, audience intent, and relevant advertising objectives.",
      icon: LuTarget,
      colorClass: "text-[#00d2ff]",
      bgClass: "bg-[#00d2ff]/10",
      borderClass: "border-[#00d2ff]/20 hover:border-[#00d2ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(0,210,255,0.25)]",
    },
    {
      title: "Contextual Audience Targeting",
      desc: "Reach users through relevant conversation context and campaign signals to improve ad relevance.",
      icon: LuUsers,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Ad Creative Strategy",
      desc: "Develop clear ad messaging and creative concepts designed to attract attention and encourage qualified clicks.",
      icon: LuPalette,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "ChatGPT Ads Management",
      desc: "Manage budgets, bids, campaign settings, and ongoing optimization to improve advertising performance.",
      icon: LuClipboardList,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Performance Optimization",
      desc: "Review campaign data to improve click quality, engagement, and conversion opportunities over time.",
      icon: LuTrendingUp,
      colorClass: "text-[#6366f1]",
      bgClass: "bg-[#6366f1]/10",
      borderClass: "border-[#6366f1]/20 hover:border-[#6366f1]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(99,102,241,0.25)]",
    },
    {
      title: "Conversion-Focused Advertising",
      desc: "Optimize ChatGPT Advertising Services around qualified traffic, lead generation, and measurable business actions.",
      icon: LuRocket,
      colorClass: "text-[#d946ef]",
      bgClass: "bg-[#d946ef]/10",
      borderClass: "border-[#d946ef]/20 hover:border-[#d946ef]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(217,70,239,0.25)]",
    },
  ],
  processSubtitle: "OUR STRATEGIC ROADMAP",
  processTitle: "How We Build Sustainable ChatGPT Advertising Growth",
  processSteps: [
    {
      step: "01",
      title: "Campaign Goal Planning",
      description: "Define clear advertising goals based on traffic, awareness, lead generation, or conversion priorities.",
      icon: LuTarget,
    },
    {
      step: "02",
      title: "Audience Context Analysis",
      description: "Identify relevant user interests, conversation themes, and commercial intent to improve ad relevance.",
      icon: LuUsers,
    },
    {
      step: "03",
      title: "Campaign Structure Setup",
      description: "Organize campaigns, objectives, budgets, and ad groups for efficient delivery and easier performance control.",
      icon: LuClipboardList,
    },
    {
      step: "04",
      title: "Bid Strategy Management",
      description: "Select and refine CPC, CPM, or oCPC approaches based on campaign goals and available performance data.",
      icon: LuTrendingUp,
    },
    {
      step: "05",
      title: "Landing Page Alignment",
      description: "Match ad messaging with relevant landing pages to improve continuity, user experience, and conversion potential.",
      icon: LuPalette,
    },
    {
      step: "06",
      title: "Reporting and Insights",
      description: "Review campaign results, cost trends, user actions, and conversion signals to guide future advertising decisions.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY BUSINESSES CHOOSE OUR CHATGPT ADS STRATEGY",
  benefitsTitle: "Building Smarter ChatGPT Advertising Performance",
  benefits: [
    "Goal-focused campaign planning",
    "Relevant audience context targeting",
    "Flexible CPC, CPM, and oCPC strategy",
    "Landing page and ad message alignment",
    "Clear reporting and performance insights",
  ],
  logoImage: "/images/serviceBanners/DigitalMarketingLatest.webp",
  whiteLogoImage: "/images/serviceBanners/digitalMarketingLatestW.webp",
};

export const chatGptAdsServices = [
  {
    icon: <LuTarget size={36} />,
    title: "Targeted Ad Visibility",
    description: "Connect with high-intent audiences actively researching solutions inside conversational AI interfaces.",
    image: "/images/MobileAppDevelopment/Android-Development.png",
    link: "/chatgpt-advertising-services-india",
  },
  {
    icon: <LuMessageSquare size={36} />,
    title: "Contextual Conversation Targeting",
    description: "Align your campaign messaging with relevant conversational signals and commercial intents.",
    image: "/images/MobileAppDevelopment/iOS-Custom.png",
    link: "/chatgpt-advertising-services-india",
  },
  {
    icon: <LuRocket size={36} />,
    title: "Conversion-Focused Optimization",
    description: "Scale leads, signups, and ROI with continuous bid strategy and landing experience refinement.",
    image: "/images/MobileAppDevelopment/Hybrid-Dev.png",
    link: "/chatgpt-advertising-services-india",
  },
];

export const chatGptAdsFaqData = [
  {
    q: "What are ChatGPT Ads Services?",
    a: "ChatGPT Ads Services help businesses plan, manage, and optimize advertising campaigns within ChatGPT advertising experiences. The focus is on reaching relevant users, improving campaign quality, and supporting measurable actions such as enquiries, registrations, or purchases.",
  },
  {
    q: "How do ChatGPT Advertising Services help businesses?",
    a: "ChatGPT Advertising Services can help businesses reach users during research and decision-making conversations. A well-structured strategy can improve message relevance, attract qualified traffic, and support broader customer acquisition goals.",
  },
  {
    q: "What is included in ChatGPT Ads Management Services?",
    a: "ChatGPT Ads Management Services may include campaign planning, objective selection, budget control, creative coordination, performance review, conversion measurement, and ongoing optimization based on available campaign data.",
  },
  {
    q: "Why work with a ChatGPT Advertising Agency?",
    a: "A ChatGPT Advertising Agency can help businesses align advertising goals, offers, messaging, measurement, and landing experiences. This can make campaign decisions more structured and easier to evaluate against actual business outcomes.",
  },
  {
    q: "Are ChatGPT Ads Services in India suitable for every business?",
    a: "ChatGPT Ads Services in India are most useful for businesses with a clear offer, defined audience, measurable conversion goals, and a suitable landing experience. The right fit depends on the business model, customer journey, budget, and advertising objectives.",
  },
];

export const chatGptAdsPortfolioData = {
  subtitle: "OUR WORK",
  title: "ChatGPT Ads Projects We're Proud Of",
  buttonText: "View All Projects",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "Conversational Ads Engine",
      badge: "Paid AI Media",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "Campaign architecture and intent targeting system for scaling leads via conversational AI ad placements.",
      downloads: "50K+",
      rating: "4.9",
      image: "/images/MobileAppDevelopment/foodie_express.png",
    },
    {
      title: "Contextual Bidding Optimizer",
      badge: "Bidding Strategy",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "Automated bid management tool matching commercial intent keywords with smart CPC and oCPC bidding.",
      downloads: "85K+",
      rating: "4.8",
      image: "/images/MobileAppDevelopment/finmate.png",
    },
    {
      title: "Conversion Continuity Suite",
      badge: "Landing Page Sync",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "System aligning conversational ad copy directly with responsive landing pages for higher conversions.",
      downloads: "65K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
  ],
};
